import React, { useState, useEffect } from "react";
import TooltipButton from "../../Button/TooltipButton";
import OrangeGradientButton from "../../Button/OrangeGradientButton";
import api from "../../../api/baseUrl";
import ExportExcelButton from "../../Button/ExportExcelButton";

import edidIcon from "../../../icons/edit.svg";
import deleteIcon from "../../../icons/trash.svg";

import ProductBulkUpload from "../../VisitorBulkUpload/ProductBulkUpload";

import viewIcon from "../../../icons/Property 1=broken (5).svg";
import PrimaryButton from "../../Button/primaryButton/PrimaryButton";
import Snackbar from "../../SnackBar/SnackBar";

import SkeletonLoader from "../../SkeletonLoader/SkeletonLoader"
import NoData from "../../NoData/NoData";
// مودال
const Modal = ({ isOpen, onClose, children, fullscreen = false }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div
                className={`modal ${fullscreen ? "fullscreen" : ""}`}
                onClick={(e) => e.stopPropagation()}
            >
                <button className="modal-close" onClick={onClose}>
                    ✕
                </button>
                {children}
            </div>
        </div>
    );
};

// جدول محصولات
const TableProducts = ({ products = [], refreshDataProducts, title, type = "product" }) => {
    const [showModal, setShowModal] = useState(false);
    const [editingItem, setEditingItem] = useState(null);
    const [formData, setFormData] = useState({});
    const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [shouldGroup, setShouldGroup] = useState(false);

    const [activeTab, setActiveTab] = useState("active"); // "active" یا "archive"

    // پیام و نوع اسنک‌بار
    const [snackbar, setSnackbar] = useState({
        title: "",
        description: "",
        type: "info",
    }); const [modalOpen, setModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const [viewingItem, setViewingItem] = useState(null);


    const [currentPage, setCurrentPage] = useState(1);
    const [pagesCount, setPagesCount] = useState(1);
    // const [pageProducts, setPageProducts] = useState([]);
    const [pageProducts, setPageProducts] = useState({
        normalMessages: [],
        archiveMessages: [],
        pagesCount: 1,
    });

    const [showNoData, setShowNoData] = useState(false);


    const [searchQuery, setSearchQuery] = useState(""); // مقدار تایپ‌شده
    const [appliedSearch, setAppliedSearch] = useState(""); // مقداری که با Enter تأیید شده

    // ---- دریافت داده از سرور ----
    // const fetchPage = async (page = 1, search = "") => {
    //     let timer;
    //     try {
    //         timer = setTimeout(() => setLoading(true), 200);
    //         const data = await refreshDataProducts(page, search);
    //         if (!data) return;
    //         setPageProducts(data.messages || []);
    //         setPagesCount(data.pagesCount || 1);
    //     } catch (err) {
    //         console.error("Error fetching page:", err);
    //     } finally {
    //         clearTimeout(timer);
    //         setLoading(false);
    //     }
    // };
    // const fetchPage = async (page = 1, search = "") => {
    //     let timer;
    //     try {
    //         timer = setTimeout(() => setLoading(true), 200);
    //         const data = await refreshDataProducts(page, search, activeTab === "archive");
    //         if (!data) return;
    //         setPageProducts(data.messages || []);
    //         setPagesCount(data.pagesCount || 1);
    //     } catch (err) {
    //         console.error("Error fetching page:", err);
    //     } finally {
    //         clearTimeout(timer);
    //         setLoading(false);
    //     }
    // };

    // ---- دریافت داده از سرور ----
    const fetchPage = async (page = 1, search = "") => {
        let timer;
        try {
            timer = setTimeout(() => setLoading(true), 1000);
            const data = await refreshDataProducts(page, search, activeTab === "archive");
            if (!data) return;
            setPageProducts(data);
            setPagesCount(data.pagesCount || 1);
        } catch (err) {
            console.error("Error fetching page:", err);
        } finally {
            clearTimeout(timer);
            setLoading(false);
        }
    };


   const handleGetDataAllProduct = async (page = 1) => {
  try {
    const result = await api.get("/get-products", { params: { page, limit: 1000 } });
    // setDataAllSeller(result.data.messages);
    return result.data.messages; // <-- برگرداندن داده‌ها برای اکسل
  } catch (error) {
    console.error("خطا:", error);
    alert("خطا در دریافت اطلاعات");
    return [];
  }
};

    useEffect(() => {
        fetchPage(currentPage, appliedSearch);
    }, [currentPage, appliedSearch, activeTab]);

    // ---- سرچ فقط بعد از زدن Enter ----
    const handleSearchKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            setCurrentPage(1);
            setAppliedSearch(searchQuery.trim());
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage < 1 || newPage > pagesCount) return;
        setCurrentPage(newPage);
    };
    // const brands = ["Troyshi", "Jeyran", "Mishen"];

    // const weightOptions = {
    //     Troyshi: ["1kg", "200g"],
    //     Jeyran: ["250g", "1kg"],
    //     Mishen: ["50g"],
    // };

    //    const brands = ["تروی", "جیران", "میشن"];

    // const weightOptions = {
    //     Troyshi: ["1 کیلو گرمی", "200 گرمی"],
    //     Jeyran: ["250 گرمی", "1 کیلو گرمی"],
    //     Mishen: ["50 گرمی"],
    // };
    const brands = ["تروی", "جیران", "میشن"];

    const weightOptions = {
        "تروی": ["1 کیلوگرم", "200 گرم"],
        "جیران": ["250 گرم", "1 کیلوگرم"],
        "میشن": ["50 گرم"],
    };


    // تغییر فرم
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // ثبت فرم
    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     let body = {};
    //     let url = "";

    //     if (type === "product") {
    //         url = "/crud-products";
    //         body = editingItem
    //             ? {
    //                 action: "update",
    //                 id: editingItem.id,
    //                 name: formData.name,
    //                 brand: formData.brand,
    //                 category: formData.category,
    //                 price: parseInt(formData.price.replace(/,/g, ""), 10)
    //             }
    //             : {
    //                 action: "add",
    //                 name: formData.name,
    //                 brand: formData.brand,
    //                 category: formData.category,
    //                 price: parseInt(formData.price.replace(/,/g, ""), 10)
    //             };
    //     }

    //     // TODO: در صورت نیاز می‌توانید visitor و seller را هم اضافه کنید

    //     try {
    //         const result = await api.post(url, body);

    //         console.log(result.data);

    //         if (editingItem) {
    //             setSnackbar({ title: "موفقیت", description: `محصول "${formData.name}" با موفقیت به‌روزرسانی شد!`, type: "success" });
    //         } else {
    //             setSnackbar({ title: "موفقیت", description: `محصول "${formData.name}" با موفقیت اضافه شد!`, type: "success" });
    //         }

    //         refreshDataProducts(); // داده‌ها دوباره از سرور گرفته می‌شوند
    //         setShowModal(false);
    //         setFormData({});

    //     } catch (error) {
    //         console.error("خطا در ارسال داده:", error);
    //         setSnackbar({ title: "ناموفق", description: editingItem ? `به‌روزرسانی محصول "${formData.name}" ناموفق بود` : `اضافه کردن محصول "${formData.name}" ناموفق بود`, type: "error" });
    //     }
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        let body = {};
        let url = "";

        if (type === "product") {
            url = "/crud-products";
            body = editingItem
                ? {
                    action: "update",
                    id: editingItem.id,
                    name: formData.name,
                    brand: formData.brand,
                    category: formData.category,
                    price: parseInt(String(formData.price || "0").replace(/,/g, ""), 10)
                }
                : {
                    action: "add",
                    name: formData.name,
                    brand: formData.brand,
                    category: formData.category,
                    price: parseInt(String(formData.price || "0").replace(/,/g, ""), 10)
                };
        }

        try {
            const result = await api.post(url, body);

            if (result.data.accepted || result.data.success) { // بسته به ساختار پاسخ سرور
                setSnackbar({
                    title: "موفقیت",
                    description: editingItem
                        ? `محصول "${formData.name}" با موفقیت به‌روزرسانی شد!`
                        : `محصول "${formData.name}" با موفقیت اضافه شد!`,
                    type: "success"
                });

        fetchPage(currentPage, appliedSearch);
                setShowModal(false);
                setFormData({});
                setEditingItem(null);
            } else {
                // اگر سرور پاسخ ناموفق داده باشد
                setSnackbar({
                    title: "ناموفق",
                    description: result.data.message || "عملیات ناموفق بود.",
                    type: "error"
                });
            }

        } catch (error) {
            console.error("خطا در ارسال داده:", error);
            setSnackbar({
                title: "ناموفق",
                description: editingItem
                    ? `به‌روزرسانی محصول "${formData.name}" ناموفق بود`
                    : `اضافه کردن محصول "${formData.name}" ناموفق بود`,
                type: "error"
            });
            // مودال باز می‌ماند تا کاربر مشکل را اصلاح کند
        } finally {
            setLoading(false);
        }
    };


    // ویرایش محصول
    const handleEditClick = (product) => {
        setEditingItem(product);
        setFormData({
            ...product,
            brand: product.brand || "",
            category: product.category || "",
        });
        setShowModal(true);
    };

    // حذف محصول
    const handleDelete = async (id) => {
        try {
            const result = await api.post("/crud-products", { action: "delete", id });
            if (result.data.accepted) {
        fetchPage(currentPage, appliedSearch);

                setSnackbar({ title: "موفقیت", description: "محصول با موفقیت حذف شد!", type: "success" });




            }
        } catch (error) {
            console.error("خطا در حذف:", error);
            setSnackbar({ title: "نا موفق", description: "حذف محصول ناموفق بود", type: "error" });

        }

    };



    // --- مشاهده جزئیات مارکتر ---
    const handleSeeDetails = async (id) => {
        try {
            const result = await api.post("/crud-products", { action: "get", id });
            setViewingItem(result.data.message[0]);
            setEditingItem(null);
            setModalOpen(true);
        } catch (error) {
            console.error("خطا در مشاهده:", error);
            setSnackbar({ message: "خطا در مشاهده", type: "error" });
        }
    };


    const displayedProducts = activeTab === "archive"
        ? pageProducts.archiveMessages
        : pageProducts.normalMessages;




    useEffect(() => {
        if (!loading) {
            if (displayedProducts.length === 0) {
                // کمی تاخیر قبل از نمایش NoData
                const timer = setTimeout(() => setShowNoData(true), 500);
                return () => clearTimeout(timer);
            } else {
                setShowNoData(false);
            }
        }
    }, [loading, displayedProducts]);
    return (
        <div className="">
            <div className="card-header">
                <h2 className="card-title">محصولات</h2>

                <div className="header-actions">
                    <div className="search-container">
                        <input
                            type="text"
                            className="search-input"
                            placeholder="جستجو بر اساس نام یا برند..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onKeyDown={handleSearchKeyDown}
                        />
                    </div>

                    <div className="button-group-header-card">
                        <ProductBulkUpload refreshDataProducts={refreshDataProducts} />
                        <ExportExcelButton fetchData={handleGetDataAllProduct}/>
                        <OrangeGradientButton
                            onClick={() => {
                                setEditingItem(null);
                                setFormData({});
                                setShowModal(true);
                            }}
                        >
                            افزودن محصول
                        </OrangeGradientButton>
                    </div>
                </div>
            </div>

            <div className="table-container">
                <div className="tabs-container">
                    <button
                        className={`tab-button ${activeTab === "active" ? "active" : ""}`}
                        onClick={() => setActiveTab("active")}
                    >
                        فعال
                    </button>
                    <button
                        className={`tab-button ${activeTab === "archive" ? "active" : ""}`}
                        onClick={() => setActiveTab("archive")}
                    >
                        بایگانی</button>


                </div>


                {loading ? (
                    <SkeletonLoader rows={20} />
                ) : displayedProducts.length > 0 ? (
                    <>
                        {/* جدول */}
                        <table>
                            <thead>
                                <tr>
                                    <th>شناسه محصول</th>
                                    <th>نام محصول</th>
                                    <th>برند محصول</th>
                                    <th>وزن محصول</th>
                                    <th>قیمت محصول</th>
                                    <th>عملیات</th>
                                </tr>
                            </thead>
                            <tbody>
                                {displayedProducts.map((product) => (
                                    <tr key={product.id}>
                                        <td>{new Intl.NumberFormat("fa-IR", { useGrouping: shouldGroup }).format(product.id)}</td>
                                        <td>{product.name} {product.brand}</td>
                                        <td>{product.brand}</td>
                                        <td>{product.category}</td>
                                        <td>{Number(product.price).toLocaleString("fa-IR")}</td>
                                        <td>

                                            <div className="button-group">

                                                <TooltipButton
                                                    icon={edidIcon}
                                                    alt="ویرایش"
                                                    tooltipText="ویرایش"
                                                    onClick={() => handleEditClick(product)}
                                                />

                                                <TooltipButton
                                                    icon={viewIcon}
                                                    alt="جزئیات"
                                                    tooltipText="جزئیات"
                                                    onClick={() => handleSeeDetails(product.id)}
                                                    className="margin-btn"
                                                />
                                                <TooltipButton
                                                    icon={deleteIcon}
                                                    alt="حذف"
                                                    tooltipText="حذف"
                                                    onClick={() => {
                                                        setDeleteItemId(product.id);
                                                        setDeleteModalOpen(true);
                                                    }}
                                                    className="delete-btn margin-btn"
                                                />


                                            </div>


                                        </td>
                                    </tr>
                                ))}
                            </tbody>

                        </table>



                        {/* Pagination */}
                        <div className="pagination">
                            {/* قبلی */}
                            <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                                قبلی
                            </button>

                            {/* دکمه‌های صفحه با ... */}
                            {Array.from({ length: pagesCount }, (_, i) => i + 1)
                                .filter((page) => {
                                    // همیشه اول، آخر و صفحات نزدیک currentPage را نشان بده
                                    return (
                                        page === 1 ||
                                        page === pagesCount ||
                                        (page >= currentPage - 1 && page <= currentPage + 1)
                                    );
                                })
                                .map((page, idx, arr) => {
                                    const prev = arr[idx - 1];

                                    // اضافه کردن ... اگر فاصله زیاد باشد
                                    if (prev && page - prev > 1) {
                                        return (
                                            <React.Fragment key={page}>
                                                <span style={{ padding: "0 5px" }}>...</span>
                                                <button
                                                    onClick={() => handlePageChange(page)}
                                                    className={currentPage === page ? "active" : ""}
                                                >
                                                    {page}
                                                </button>
                                            </React.Fragment>
                                        );
                                    }

                                    return (
                                        <button
                                            key={page}
                                            onClick={() => handlePageChange(page)}
                                            className={currentPage === page ? "active" : ""}
                                        >
                                            {page}
                                        </button>
                                    );
                                })}

                            {/* بعدی */}
                            <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === pagesCount}>
                                بعدی
                            </button>


                        </div>

                    </>) : showNoData ? (
                        <div className="no-data-message">
                            <NoData message="هیچ فروشگاهی یافت نشد" />
                        </div>
                    ) : null}







                {/* Snackbar */}
                {snackbar.title && (
                    <Snackbar
                        title={snackbar.title}
                        description={snackbar.description}
                        type={snackbar.type}
                        duration={2000}
                        onClose={() => setSnackbar({ title: "", description: "", type: "info" })}
                    />
                )}



            </div>



            {/* مودال افزودن/ویرایش */}
            <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
                <h2 className="modal-title">{editingItem ? "ویرایش محصول" : "افزودن محصول جدید"}</h2>
                <form className="modal-form" onSubmit={handleSubmit}>
                    {[
                        { key: "name", label: "نام محصول", type: "text", required: true },
                        { key: "brand", label: "برند", type: "select", options: brands, required: true },
                        {
                            key: "category",
                            label: "وزن",
                            type: "select",
                            options: weightOptions[formData.brand] || [],
                            required: true,
                        },
                        { key: "price", label: "قیمت (تومان)", type: "text", required: true },
                    ].map((field) => (
                        <div key={field.key} className="form__input-group">
                            {field.type === "select" ? (
                                <select
                                    id={field.key}
                                    name={field.key}
                                    value={formData[field.key] || ""}
                                    onChange={handleChange}
                                    required={field.required}
                                    className="form__input"
                                >
                                    <option value="">
                                        {field.key === "brand"
                                            ? "انتخاب برند"
                                            : field.key === "category"
                                                ? "انتخاب وزن"
                                                : ""}
                                    </option>
                                    {field.options.map((option) => (
                                        <option key={option} value={option}>
                                            {option}
                                        </option>
                                    ))}
                                </select>
                            ) : (
                                <input
                                    id={field.key}
                                    name={field.key}
                                    type={field.type}
                                    value={formData[field.key] || ""}
                                    placeholder=" "
                                    required={field.required}
                                    onChange={(e) => {
                                        if (field.key === "price") {
                                            // حذف همه چیز به جز اعداد
                                            let value = e.target.value.replace(/\D/g, "");
                                            // فرمت سه‌رقمی با کاما
                                            const formattedValue = value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                            setFormData({ ...formData, price: formattedValue });
                                        } else {
                                            handleChange(e);
                                        }
                                    }}
                                    className="form__input"
                                />
                            )}
                            <label htmlFor={field.key} className="form__input-label">
                                {field.label}
                            </label>
                        </div>
                    ))}

                    <PrimaryButton title="ذخیره" type="submit" loading={loading} />
                </form>

            </Modal>

            {/* مودال حذف */}
            {isDeleteModalOpen && (
                <Modal isOpen={isDeleteModalOpen} onClose={() => setDeleteModalOpen(false)}>
                    <h3 className="delete-modal-title">آیا مطمئن هستید که می‌خواهید این مورد را حذف کنید؟</h3>
                    <div className="modal-buttons">
                        <button className="btn cancel-btn" onClick={() => setDeleteModalOpen(false)}>
                            انصراف
                        </button>
                        <button
                            className="btn confirm-btn"
                            onClick={() => {
                                handleDelete(deleteItemId);
                                setDeleteModalOpen(false);
                            }}
                        >
                            تایید
                        </button>
                    </div>
                </Modal>
            )}

            {/* مودال جزئیات مارکتر */}
            {modalOpen && viewingItem && (
                <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)}>
                    <div className="modal-info-content">
                        <h3 className="modal-title">جزئیات محصول</h3>
                        <div className="modal-info">
                            <div className="info-row">
                                <span className="info-label">نام:</span>
                                <span className="info-value">{viewingItem.name}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">برند:</span>
                                <span className="info-value">{viewingItem.brand}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">دسته‌بندی:</span>
                                <span className="info-value">{viewingItem.category}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">قیمت:</span>
                                <span className="info-value">
                                    {Number(viewingItem.price).toLocaleString("fa-IR")} تومان
                                </span>
                            </div>
                        </div>
                    </div>
                </Modal>

            )}


        </div>
    );
};

export default TableProducts;
